import { Icon16InfoCirle } from '@vkontakte/icons';
import clsx from 'clsx';
import { useState } from 'react';
// import ReactTooltip from 'react-tooltip';
import { twMerge } from 'tailwind-merge';
import Button, { ButtonType } from '../Button';

export interface TableValue {
  key: any;
  value: any;
  info?: any;
}

export type TableColumn = TableValue[];

interface ITableProps {
  columns: TableColumn[]; // Each TableColumn represents the key value pairs in one column (pass columns in left to right order)
  classNames?: {
    container?: string;
    row?: string;
    key?: string;
    value?: string;
  };
}

export default function DictTable({ columns = [], classNames }: ITableProps) {
  const maxRows = columns.length ? Math.max(...columns.map((col) => col.length)) : 0;
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  return (
    <div className={twMerge('w-full divide-y-1 divide-line-primary rounded-2xl', classNames?.container)}>
      {Array(maxRows)
        .fill(0)
        .map((_, i) => {
          const row = columns.map((col) => col[i]);
          return (
            <div
              key={i}
              className="flex flex-col md:flex-row w-full divide-y-0.5 md:divide-y-0 md:divide-x-0.5 divide-line-primary md:space-x-4"
            >
              {row.map((cell: TableValue, j) => {
                return (
                  <div
                    key={j}
                    className={twMerge(
                      clsx('flex w-full justify-between items-center py-4', {
                        'md:pl-6': j > 0,
                      }),
                      classNames?.row
                    )}
                  >
                    {cell && (
                      <>
                        <div className={twMerge('text-secondary', classNames?.key)}>{cell.key}</div>
                        <div className={twMerge('flex items-center', classNames?.value)}>
                          {cell.value}
                          {/* {cell.info && (
                            <>
                              <Button
                                dataTip
                                dataFor={cell.info.title}
                                setShowTooltip={setShowTooltip}
                                type={ButtonType.IconButton}
                                className="w-4 h-4 text-t-2 p-0 ml-4"
                              >
                                <Icon16InfoCirle width={14} height={14} />
                              </Button>
                              {showTooltip && (
                                <ReactTooltip
                                  id={cell.info.title}
                                  type="dark"
                                  multiline
                                  effect="solid"
                                  backgroundColor="#000"
                                  className="!bg-b-3 !opacity-100 !rounded-xl !shadow-md !text-md text-center"
                                  arrowColor="#1B1A27"
                                >
                                  <div style={{ whiteSpace: 'pre-line' }}>{cell.info.text}</div>
                                </ReactTooltip>
                              )}
                            </>
                          )} */}
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
    </div>
  );
}
